import React from "react";
import '../_gender-select-dropdown.scss';

const baseClass = 'genderSelectDropdown'

interface GenderSelectOptionPropTypes {
  genderOption: any,
  isOptionSelected?: boolean,
  handleOptionSelections?: any
}

const GenderSelectOption = (props: GenderSelectOptionPropTypes): JSX.Element => {
  return (
    <div className={`${baseClass}-content-wrapper ${props.isOptionSelected ? 'is-selected' : 'not-selected'}`}
         onClick={() => props.handleOptionSelections(props.genderOption)}>
      <div className={`${baseClass}-gender-text`}>
        {props.genderOption.name}
      </div>
      <div className={`${baseClass}-circle-one`}>
        <div className={`${baseClass}-circle-two ${props.isOptionSelected ? 'is-selected' : 'not-selected'}`}></div>
      </div>
    </div>
  )
}

export default GenderSelectOption;
